const doc = [({"en":({"js":({"admin":({"contacts":({"edit":({"student_council_content":({"student_council_information":"Student council information"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;